/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Report, Stage, State, Helpers, HistoryStage, FilterPreference, PreferenceRequest, User} from '../../../model';
import {ReportProvider, UserProvider, StageProvider, ClientProvider, PreferenceProvider, TagProvider} from '../../../providers';
import {Subject} from 'rxjs';
import {ConfirmDeleteReportModal} from './modal/confirm-delete/confirm-delete-report.modal';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ReportService} from '../../../services/report.service';
import {NewReportModal} from './modal/new-report/new-report.modal';
import {
  CalculationService,
  StageService,
  StateService,
  UserPersistenceService,
  DashboardService,
  StompClient,
  ModeService,
  UserService,
  RightMenuService,
  LogService
} from '../../../services';
import * as moment from 'moment';
import { ConfirmRevertModal, ReportDelayModal, ReportStageModal } from '../report/modals';
import { StageChangeRequest, ReportUsers, ReportDelay } from 'src/app/model/report';
import { ConfirmNextStageModal } from './modal/confirm-stage/confirm-next-stage.modal';
import { ReportNotesModal } from './modal/notes/report-notes.modal';
import { ReportNote } from 'src/app/model/report.note';
import { CrmAlertComponent } from '../../fields';
import { PresetValue } from 'src/app/model/preset-value';
import { SearchableItem } from 'src/app/model/interface/searchable.item';
import { QueryType } from 'src/app/model/enums/query.type';
import { Tag } from 'src/app/model/tag';
import { SystemType } from 'src/app/model/enums/system.type';
import { MenuItem } from 'src/app/model/menu-item';
import { RightClickMenu } from 'src/app/model/enums/right-click-menu.enum';
import {ArchiveReportsModalComponent} from "./modal/archive-reports/archive-reports-modal.component";

@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.page.html',
  styleUrls: ['dashboard.page.scss']
})

export class DashboardPage implements OnInit, OnDestroy {
  private stompSubscription: any;
  @ViewChild('alert') alert: CrmAlertComponent;

  menuClickSubscription: any;

  constructor(
    private router: Router,
    private reportService: ReportService,
    public reportProvider: ReportProvider,
    private stageService: StageService,
    private stageProvider: StageProvider,
    private stateService: StateService,
    public userProvider: UserProvider,
    public clientProvider: ClientProvider,
    private modalService: BsModalService,
    public calcService: CalculationService,
    private userPersistenceService: UserPersistenceService,
    private dashboardService: DashboardService,
    private preferenceProvider: PreferenceProvider,
    private stompClient: StompClient,
    private modeService: ModeService,
    private userService: UserService,
    private route: ActivatedRoute,
    private tagProvider: TagProvider,
    private rightMenuService: RightMenuService,
    private loggerService : LogService,
  ) {
    this.reportService.clearReport();

    this.menuClickSubscription = this.rightMenuService.listenTriggeredMenuItem().subscribe(menuItem => {
      if (menuItem) {
        switch (menuItem.item.action) {
        case RightClickMenu.OPEN_IN_NEW_TAB:
          this.goReport(menuItem.report, true);
          break;
        default:
          break;
        }
      }
    });
  }

  totalItems = 0;
  currentPage = 1;
  queryString = '';
  currentSize = 10;
  selectedSize = this.currentSize;
  reports: Report[] = [];
  /*  preferences: Preference[] = [];
  preference: Preference; */
  preferenceRequest: PreferenceRequest;
  filter: FilterPreference = new FilterPreference();
  selectAll = false;
  reportsLoading = false;
  preferenceLoading = false;

  noteModal: BsModalRef;
  deleteModal: BsModalRef;
  newReportModal: BsModalRef;
  exportModalRef: BsModalRef;
  createModal: BsModalRef;
  modalRef: BsModalRef;
  stages: Stage[];
  states: State[];
  stagesSub: any;
  statesSub: any;
  preferenceSub: any;
  nextStageId: string;
  isLoading = false;
  today: Date = new Date();
  isDesc = true;
  column = 'CREATED_DATE';
  sliderValue: number;
  reverModal: BsModalRef;
  changeStageModal: BsModalRef;
  confirmStageModal: BsModalRef;

  currentMode: SystemType;
  modeSub: any;
  user: User;
  private userSub: any;
  navSub: any;
  tags: Tag[] = [];

  selectedQueryType: any = PresetValue.create('All', QueryType.ALL);

  queryTypes: SearchableItem[] = [
    PresetValue.create('All', QueryType.ALL),
    PresetValue.create('Company Name', QueryType.COMPANY_NAME),
    PresetValue.create('Company DBA', QueryType.COMPANY_DBA),
    PresetValue.create('Bank', QueryType.CLIENT),
    PresetValue.create('Lender Name', QueryType.LENDER_NAME),
    PresetValue.create('Lender Email', QueryType.LENDER_EMAIL),
    PresetValue.create('Internal File Name', QueryType.INTERNAL_NAME)
  ];
  rowStyle = 'L';
  paramSub: any;
  isHistoryReports: boolean = false;
  week_start: string = '';
  week_end: string = '';

  archivePopupOpen: boolean = false;

  ngOnInit(): void {
    if(localStorage.getItem('R-CRM-DASH-FILTER-PREF'))
      this.selectedQueryType = JSON.parse(localStorage.getItem('R-CRM-DASH-FILTER-PREF'));

    this.paramSub = this.route.queryParams.subscribe(params => {
      if (params){
        if(params.stats === 'ENGAGED'){
          this.isHistoryReports = true;
          this.week_start = params.week_start;
          this.week_end = params.week_end;
        }
      }
    });

    this.navSub = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.loadReports(1);
        this.isHistoryReports = false;
      }
    });

    this.stagesSub = this.stageService.stages$.subscribe(stage => this.stages = stage);
    this.statesSub = this.stateService.states$.subscribe(state => this.states = state);
    this.userSub = this.userService.user$.subscribe(u => this.user = u);
    /*   this.preferenceSub = this.dashboardService.preferences$.subscribe(pref=> this.preferences = pref); */

    this.modeSub = this.modeService.mode$.subscribe(mode => {
      if(mode){
        this.currentMode = mode;
        //this.dashboardService.preference.next(null);
        //this.preferenceLoading = true;

        /* if (this.preferences.length === 0) {
          this.preferenceProvider.getPreferences().subscribe(data => {
            if (data) {
              if (data.success) {
                this.preferences = Preference.parseArray(data.result);
                this.dashboardService.setPreferences(this.preferences);


                this.loadPreference();
              }
            }
          });
        } else {
          this.dashboardService.setPreferences(this.preferences);
          this.loadPreference();
        } */

        /* this.preferenceProvider.getPreferences().subscribe(data => {
          if (data) {
            if (data.success) {
              this.preferences = Preference.parseArray(data.result).filter(p => p.TYPE == this.currentMode);
              this.dashboardService.setPreferences(this.preferences);
              this.loadPreference();
            }
          }
        }); */
      }
    });

    this.stompSubscription = this.stompClient
      .subscribe('/dashboard')
      .subscribe(() => {
        this.loadReports(1);
      });

    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SLIDER_VALUE')) {
      let number = Number(localStorage.getItem('R-CRM-SLIDER_VALUE'));
      this.rowStyle = number === 1 ? 'S' : number === 2 ? 'M' : 'L';
    }

    this.loadTags();
  }

  ngOnDestroy(): void {
    if(this.stagesSub) this.stagesSub.unsubscribe();
    if(this.stagesSub) this.stagesSub.unsubscribe();
    if(this.stompSubscription) this.stompSubscription.unsubscribe();
    if(this.preferenceSub) this.preferenceSub.unsubscribe();
    if (this.modeSub) this.modeSub.unsubscribe();
    if (this.userSub) this.userSub.unsubscribe();
    if (this.paramSub) this.paramSub.unsubscribe();
    if (this.navSub) this.navSub.unsubscribe();
    if(this.menuClickSubscription) this.menuClickSubscription.unsubscribe();
  }

  onFilterValueChanged(filter: FilterPreference): void {
    this.filter = filter;
    if(this.isHistoryReports)
      this.getHistoryReports(1);
    else
      this.loadReports(1);
  }

  loadReports(page: number): void {
    this.isDesc = this.filter.isDesc;
    this.column = this.filter.column;

    this.currentSize = this.filter.size;
    this.selectedSize = this.filter.size;
    this.sliderValue = this.filter.sliderValue;

    this.reportsLoading = true;
    this.currentPage = page;
    this.isLoading = true;

    this.reportProvider.getFilteredReports(page, this.selectedSize, this.isDesc, this.column, this.currentMode, this.selectedQueryType.VALUE, this.queryString,
      this.filter.selectedStates.length > 0 ? this.filter.selectedStates : null,
      this.filter.selectedStages.length > 0 ? this.filter.selectedStages : null,
      this.filter.selectedAssignee.length > 0 ? this.filter.selectedAssignee : null,
      this.filter.selectedProcessor.length > 0 ? this.filter.selectedProcessor : null,
      this.filter.selectedResearchAnalyst.length > 0 ? this.filter.selectedResearchAnalyst : null,
      this.filter.selectedFinancialAnalyst.length > 0 ? this.filter.selectedFinancialAnalyst : null,
      this.filter.selectedSeniorAnalyst.length > 0 ? this.filter.selectedSeniorAnalyst : null,
      this.filter.selectedBanks.length > 0 ? this.filter.selectedBanks : null,
      this.filter.getDelay(),
      this.filter.selectedTags.length > 0 ? this.filter.selectedTags : null,
      this.filter.selectedEaProcessor.length > 0 ? this.filter.selectedEaProcessor : null,
      this.filter.selectedEaResearchAnalyst.length > 0 ? this.filter.selectedEaResearchAnalyst : null,
      this.filter.selectedEaAppraiser.length > 0 ? this.filter.selectedEaAppraiser : null,
      this.filter.selectedEaReviewer.length > 0 ? this.filter.selectedEaReviewer : null,
      this.filter.selectedMiscs.length > 0 ? this.filter.selectedMiscs : null)
      .subscribe(
        data => {
          if (data.success) {
            this.reports = this.userPersistenceService.persistReportAssignee(data.result.items);
            this.totalItems = data.result.totalItems;
          }
          this.isLoading = false;
          this.reportsLoading = false;
        });

  }

  /* Load statistics report */
  getHistoryReports(page: number): void{
    this.selectedSize = this.filter.size;
    this.currentPage = page;

    this.reportsLoading = true;
    this.isLoading = true;

    this.reportProvider.getHistoryReports(page, this.selectedSize, this.currentMode, this.week_start, this.week_end)
      .subscribe(
        data => {
          if (data.success) {
            this.reports = this.userPersistenceService.persistReportAssignee(data.result.items);
            this.totalItems = data.result.totalItems;
          }
          this.isLoading = false;
          this.reportsLoading = false;
        });
  }

  createNewReport(): void {
    this.newReportModal = this.modalService.show(NewReportModal, Helpers.getModalConfig());
    const ackSubject = new Subject<any>();
    this.newReportModal.content.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value.ACCEPT) {
        this.reportProvider.createReport(value.COMPANY_NAME, value.STAGE, value.REPORT_TYPE, this.currentMode)
          .subscribe(
            data => {
              if (data.success) {
                this.reportService.setReport(Report.parse(data.result));

                if(this.currentMode === SystemType.BV)
                  this.router.navigate(['/report', data.result.ID, 'general']);
                else if(this.currentMode === SystemType.EA)
                  this.router.navigate(['/report-ea', data.result.ID, 'general']);
              }
            });
      }
    });
  }

  deleteReport(report: Report, index: number): void {
    this.alert.hide();
    this.deleteModal = this.modalService.show(ConfirmDeleteReportModal, Helpers.getModalConfig());
    const ackSubject = new Subject<boolean>();
    this.deleteModal.content.subject = ackSubject;
    this.deleteModal.content.report = report;

    ackSubject.subscribe(value => {
      if (value) {
        this.reportProvider.deleteReport(report.ID)
          .subscribe(
            data => {
              if (data.success)
                this.reports.splice(index, 1);
              else
                this.alert.show(data.error);
              setTimeout(() => {
                this.alert.hide();
              }, 3000);
            });
      }
    });
  }

  onDeleteMultiple(ids:string[]): void {
    this.alert.hide();
    this.reportProvider.deleteReports(ids)
      .subscribe(
        data => {
          if (data.success)
            this.loadReports(1);
          else {
            this.alert.show(data.error);
            setTimeout(() => {
              this.alert.hide();
            }, 3000);
          }
        });
  }

  goReport(report: Report, isNewTab: boolean = false): void {
    report.isLoading = true;
    this.reportProvider.getReportById(report.ID)
      .subscribe(data => {
        if (data.success) {
          report.isLoading = false;

          if(this.currentMode == SystemType.BV){
            if(isNewTab){
                /*const url = this.router.serializeUrl(
                  this.router.createUrlTree(['/report', report.ID, 'general'], { state: { report: data.result } })
                );
                window.open(url, '_blank');*/
              }
              else {
                this.router.navigate(['/report', report.ID, 'general'], { state: { report: data.result } });
              }
          }
          else if (this.currentMode === SystemType.EA) {
            if(isNewTab){
                /*const url = this.router.serializeUrl(
                  this.router.createUrlTree(['/report', report.ID, 'general'], { state: { report: data.result } })
                );
                window.open(url, '_blank');*/
              }
              else {
                this.router.navigate(['/report-ea', report.ID, 'general'],{ state: { report: data.result } });
              }
          }
        }
      });
  }

  searchReport(value: string): void {
    this.queryString = value;
    this.loadReports(1);
  }

  pageChanged(event: any): void {
    if (event.page !== this.currentPage){
      if(this.isHistoryReports)
        this.getHistoryReports(1);
      else
        this.loadReports(event.page);
    }
  }

  onSelectAll(): void {
    if (this.reports) {
      for (let i = 0; i < this.reports.length; i++)
        this.reports[i].selected = !this.selectAll;
    }
  }

  dateDiff(date: Date, add: number = null): number {
    if(add)
      return moment(date).add(add, 'days').diff(moment(), 'days');
    else return moment(date).diff(moment(), 'days');
  }

  dateVal(date: Date, add: number = null): number {
    if(add)
      return moment(date).add(add, 'days').diff(moment(), 'days');
    else return moment(date).diff(moment(), 'days');
  }

  showDeadline(state: State): boolean {
    if (state.ID === 'CMP' || state.ID === 'CCD' || state.ID === 'LST') {
      return false;
    }

    return true;
  }

  revertReport(report: Report): void {
    this.reverModal = this.modalService.show(ConfirmRevertModal, Helpers.getModalConfig());
    const ackSubject = new Subject<Boolean>();
    this.reverModal.content.subject = ackSubject;

    ackSubject.subscribe(result => {
      if (result) {
        this.reportProvider.revertReport(report.ID)
          .subscribe(data => {
            if (data.success) {
              const historyStage = HistoryStage.parse(data.result);

              if (historyStage) {

                const stage = this.stageService.getStageById(historyStage.SID);

                report.STAGE = stage;

                if (historyStage.STATE) {
                  report.STATE = historyStage.STATE;
                }

                if (historyStage.ASSIGNEE) {
                  report.ASSIGNEE = historyStage.ASSIGNEE;
                }

              }
            }
          });
      }
    });
  }

  onNextStage(report: Report): void {
    let stageRequest: StageChangeRequest = new StageChangeRequest();
    let users: ReportUsers;

    this.reportProvider.getReportUsers(report.ID)
      .subscribe(data => {
        if (data.success) {

          users = ReportUsers.parse(data.result);
          stageRequest = this.reportService.getReportStageRequest(this.nextStageId, users);

          if (stageRequest.ASSIGNEE_TYPE_USER) {

            this.confirmStageModal = this.modalService.show(ConfirmNextStageModal, Helpers.getModalConfig());
            const ackSubject = new Subject<Boolean>();
            this.confirmStageModal.content.subject = ackSubject;

            ackSubject.subscribe(result => {
              if (result) {
                this.reportProvider.setStage(report.ID, stageRequest)
                  .subscribe(historyData => {
                    if (historyData.success) {
                      const history: HistoryStage = HistoryStage.parse(historyData.result);
                      report.STAGE = this.stageService.getStageById(history.SID);
                      report.ASSIGNEE = history.ASSIGNEE;
                      report.STATE = history.STATE;
                    }
                  });
              }
            });

          } else {

            this.changeStageModal = this.modalService.show(ReportStageModal, Helpers.getModalConfig());
            const ackSubject = new Subject<HistoryStage>();
            this.changeStageModal.content.subject = ackSubject;
            this.changeStageModal.content.reportId = report.ID;
            this.changeStageModal.content.nextStageId = this.nextStageId;
            this.changeStageModal.content.userList = users;
            this.changeStageModal.content.disabledInput = false;
            this.changeStageModal.content.setReportUsers();
            this.changeStageModal.content.getReportUser();
            this.changeStageModal.content.setStageList();

            ackSubject.subscribe(value => {
              if (value) {
                report.STAGE = this.stageService.getStageById(value.SID);
                report.ASSIGNEE = value.ASSIGNEE;
                report.STATE = value.STATE;
              }
            });
          }
        }
      });
  }

  delayReport(report: Report): void {
    let delay: ReportDelay = new ReportDelay();
    this.reportProvider.getReportDelay(report.ID).subscribe(data => {
      if (data.success) {
        delay = ReportDelay.parse(data.result);
        report.ACTIVE_DELAY = delay;
        this.reportService.report.next(report);
      }
    });

    this.reverModal = this.modalService.show(ReportDelayModal, Helpers.getModalConfig());
    const ackSubject = new Subject<Boolean>();
    this.reverModal.content.subject = ackSubject;
    ackSubject.subscribe(result => {
      if (result) {
        this.loggerService.log(result) ;
      }
    });
  }

  getNextStage(report: Report): Stage {
    this.nextStageId = this.stageService.getNextStageId(report.STAGE.ID);
    if (this.stages)
      return this.stages.filter(stage => stage.ID === this.nextStageId)[0];
    else return null;
  }

  saveSortColumn(): void {
    localStorage.setItem('R-CRM-SORT_COLUMN', this.column);
    localStorage.setItem('R-CRM-SORT_ORDER', this.isDesc.toString());
    localStorage.setItem('R-CRM-SORT_SIZE', this.selectedSize.toString());
  }

  retrieveSaveColumns(): void {
    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SORT_COLUMN')){
      this.filter.column = localStorage.getItem('R-CRM-SORT_COLUMN');
      /* this.column = localStorage.getItem('R-CRM-SORT_COLUMN'); */
    }

    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SORT_ORDER')){
      this.filter.isDesc = localStorage.getItem('R-CRM-SORT_ORDER') === 'true' ? true : false;
    /*   this.isDesc = localStorage.getItem('R-CRM-SORT_ORDER') === 'true' ? true : false; */
    }

    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SORT_SIZE')){
      this.filter.size = Number(localStorage.getItem('R-CRM-SORT_SIZE'));
      /*  this.selectedSize = Number(localStorage.getItem('R-CRM-SORT_SIZE'));
      this.currentSize = Number(localStorage.getItem('R-CRM-SORT_SIZE')); */
    }

    // eslint-disable-next-line no-prototype-builtins
    if (localStorage.hasOwnProperty('R-CRM-SLIDER_VALUE')) {
      this.filter.sliderValue = Number(localStorage.getItem('R-CRM-SLIDER_VALUE'));
      this.onChangeValue({value: this.filter.sliderValue});
    }
  }

  /**
   * Open modal to export
   * @param template
  */
  openPageExportModal(template: TemplateRef<any>): void {
    this.exportModalRef = this.modalService.show(template, { backdrop: 'static' });
  }

  /**
   * Close notes modal .
  */
  closeModal(): void {
    this.exportModalRef.hide();
  }

  checkSelectAll():void {
    let reportDiff = this.reports.find((report) => {
      if(!report.selected){
        return report;
      }
    });
    this.selectAll = !reportDiff ? true : false;
  }

  setReportNote(report: Report): void {
    this.noteModal = this.modalService.show(ReportNotesModal, Helpers.getModalConfig());
    const ackSubject = new Subject<ReportNote>();
    this.noteModal.content.subject = ackSubject;
    this.noteModal.content.report = report;

    ackSubject.subscribe(value => {
    });
  }

  sizeChange(value: any): void {
    if (value !== this.selectedSize) {
      this.selectedSize = value;
      this.filter.size = this.selectedSize;
      this.filter.isChanged = true;
      this.saveSortColumn();
      this.loadReports(1);
    }
  }

  selectQueryType(type: PresetValue): void {
    this.selectedQueryType = type;
    localStorage.setItem('R-CRM-DASH-FILTER-PREF', JSON.stringify(this.selectedQueryType));
  }

  onChangeValue(event: any): void {
    // TODO this is for dashboard row style. it should change according to the rowStyle value
    if(event.value == 1)
      this.rowStyle = 'S';
    if(event.value == 2)
      this.rowStyle = 'M';
    if(event.value == 3)
      this.rowStyle = 'L';
  }

  reportDeleted(event): void{
    let index = -1;
    this.reports.map((rep, i) => {
      if(rep.ID === event)
        index = i;
    });
    if(index > -1)
      this.reports.splice(index, 1);
  }

  // when tags click
  onFilterTagChanged(tag: Tag): void {
    const found = this.filter.selectedTags.find(t => t.ID === tag.ID);
    if (!found)
      this.filter.selectedTags.push(tag);

    this.loadReports(1);
  }

  loadTags(): void {
    this.tagProvider.getQuickAccessTags()
      .subscribe(data => {
        this.tags = Tag.parseArray(data.result);
      }, err => {
        this.loggerService.error(err);
      });
  }

  isDataEntryRole(): boolean {
    return this.userService.isDataEntryRole();
  }

  isCoreAccess(): boolean {
    return this.userService.isCoreAccess();
  }

  /**
   * @description for show
   * @param $event keyboard event
   */
  @HostListener('window:keydown', ['$event'])
  onKeyPress($event: KeyboardEvent) {
    if ($event.ctrlKey || $event.metaKey) {
      if ($event.keyCode == 76 && !this.archivePopupOpen) { // l
        this.archiveReport();
      }
    }
  }

  archiveReport(): void {
    this.archivePopupOpen = true;
    this.newReportModal = this.modalService.show(ArchiveReportsModalComponent, Helpers.getModalConfig());
    const ackSubject = new Subject<number>();
    this.newReportModal.content.subject = ackSubject;

    ackSubject.subscribe(value => {
      this.archivePopupOpen = false;
      if (value) {
        this.reportProvider.archiveReport(value)
          .subscribe(
            data => {
              if (data.success) {
                this.loadReports(1);
              }
            });
      }
    });
  }

}
